import React, { useState } from 'react';
import { ModalWrapper, LecturerHistoryTable } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { Space } from 'antd';
import { useLecturerHistory } from 'hooks';
import SearchBox from './SearchBox'

export interface LecturerHistoryModalProps extends PopupProps {
    lecturer_srl: number;
    name: string;
}

const LecturerHistoryModal = ({ 
    isOpen, 
    onClose, 
    name, lecturer_srl}: LecturerHistoryModalProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    
  const [searchParams, setSearchParams] = useState<LecturerHistoryListReqDto>({id: lecturer_srl});
    
  /* ======================================================
  * hooks
  * ====================================================== */
  const {historyList, searchResult} = useLecturerHistory(searchParams);        
   /* ======================================================
   * variables
   * ====================================================== */

   /* ======================================================
   * events
   * ====================================================== */

    const onCloseClick = () => {
        onClose?.();
    }

    const onSearch = (data: any) => {
        setSearchParams({...searchParams, ...data});
    };

    const onReset = () => {
        setSearchParams({id: lecturer_srl});
    };

  /* ======================================================
   * effects
   * ====================================================== */
 
    return (
    <ModalWrapper open={isOpen} onCancel={onCloseClick} width={1400} title={"강의 히스토리"} closable>
        <Space direction='vertical' style={{width:'100%'}}>
            <div>
                <h3>{name}님에 대한 검색 결과 입니다.</h3>
            </div>
            <SearchBox onSearch={onSearch} onReset={onReset} /> 
            <LecturerHistoryTable historyList={historyList} searchResult={searchResult} onSearch={onSearch} />
        </Space>        
    </ModalWrapper>  
    )    
};

export default React.memo(LecturerHistoryModal);    